import { createApp } from 'vue';

import CartDrawer from '~/components/cart-drawer.vue';
import * as DataDogLogs from '~/lib/datadog/datadog';

import { BaseSection } from './base-section';

class CartDrawerSection extends BaseSection {
  constructor() {
    super('[data-section-type="cart-drawer-section"]');
  }

  init(instanceData) {
    const container = instanceData.container;

    if (!container) {
      DataDogLogs.error(
        '[Allbirds section] - Cart Drawer - init - Container not found',
        {},
        new Error('Container not found'),
      );
      return;
    }

    const dataset = container.dataset;
    const urlParams = new URLSearchParams(window.location.search);
    const openCartDrawer = urlParams.get('openCartDrawer');
    const props = {
      addButtonText: dataset.addButtonText,
      checkoutButtonLabel: dataset.checkoutButtonLabel,
      colorLabel: dataset.colorLabel,
      emptyCartDisplayImages: dataset.emptyCartDisplayImages === 'true',
      emptyCartLinks: JSON.parse(dataset.emptyCartLinks || '[]'),
      emptyCartTitle: dataset.emptyCartTitle,
      enabledPaymentTypes: JSON.parse(dataset.enabledPaymentTypes || '[]'),
      freeShippingMessageAchieved: dataset.freeShippingMessageAchieved,
      freeShippingMessageNotAchieved: dataset.freeShippingMessageNotAchieved,
      freeShippingThreshold: parseInt(dataset.freeShippingThreshold, 10) || 7500,
      giftNoteEnabled: dataset.giftNoteEnabled === 'true',
      giftNoteLabel: dataset.giftNoteLabel,
      giftNoteTitle: dataset.giftNoteTitle,
      openCartDrawer: openCartDrawer === 'true',
      showFreeShippingThreshold: dataset.showFreeShippingThreshold === 'true',
      sizeLabel: dataset.sizeLabel,
      subtotalLabel: dataset.subtotalLabel,
      upsellProducts: dataset.upsellProducts,
      upsellsAddLabel: dataset.upsellsAddLabel,
    };

    createApp({
      components: {
        CartDrawer,
      },
      data() {
        try {
          props.upsellProducts = JSON.parse(props.upsellProducts || '[]');
        } catch (error) {
          DataDogLogs.error(
            '[Allbirds section] - Cart Drawer - init - Error parsing upsellProducts',
            { props },
            error,
          );
        }
        return { props };
      },
      name: 'CartDrawerApp',
      template: '<cart-drawer v-bind="props" />',
    }).mount(container);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CartDrawerSection();
});
